// api/postQuestionUseCase.js (create-question.js)

import { ENV } from "../Utils";

export const postQuestionUseCase = async (
  accessToken,
  threadId,
  data,
  assistantId,
) => {
  try {
    // --- CORRECCIÓN CLAVE ---
    // Cambiamos THREADGET por THREADGETEDUCA para que coincida con la ruta del servidor.
    const url = new URL(
      `${ENV.BASE_API}/${ENV.API_ROUTES.THREADGETEDUCA}/${threadId}/${assistantId}`,
    );
    url.searchParams.append("data", data);

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!resp.ok) {
      const errorData = await resp
        .json()
        .catch(() => ({ message: resp.statusText }));
      throw new Error(
        `Error del servidor: ${resp.status} - ${errorData.message}`,
      );
    }

    // El resto de la lógica para retornar el resultado completo ya es correcta.
    const result = await resp.json();
    return result;
  } catch (error) {
    console.error("Error en la función postQuestionUseCase:", error);
    throw error;
  }
};
